<template>
  <router-view />
</template>

<script>
import getUserPermissions from '@/utils/user-permissions';

export default {
  name: 'HRWidget',
  metaInfo: {
    title: 'HR |'
  },
  mounted() {
    if (!getUserPermissions()[this.$Constants.PERMISSIONS.HR_APPROVAL]) {
      this.$router.push({ name: this.$RouteNames.dashboard });
    }
  }
};
</script>
